import { render } from "./AssessmentHeader.vue?vue&type=template&id=4710cf0b&scoped=true"
import script from "./AssessmentHeader.vue?vue&type=script&lang=js"
export * from "./AssessmentHeader.vue?vue&type=script&lang=js"

import "./AssessmentHeader.vue?vue&type=style&index=0&id=4710cf0b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4710cf0b"

export default script